import 'jquery-nice-select';

function initForm($block) {
  const $form = $block.find('form');

  // Fix submit button
  $form
    .find('.af-submit-button')
    .html(
      `<span class="wp-block-button__text">${$form
        .find('.af-submit-button')
        .html()}</span>`
    );

  // Add class to select to change the color
  $form.find('select').on('change', function () {
    if ($(this).val()) {
      $(this).addClass('selected');
    } else {
      $(this).removeClass('selected');
    }
  });

  // Nice select
  $form.find('select').niceSelect();

  // Fix select z index
  let zIndex = 30;
  $form.find('.af-field-type-select').each(function () {
    $(this).css('z-index', zIndex);
    zIndex -= 1;
  });

  // Adding class to first and last checkbox
  $form
    .find('.af-field-type-checkbox, .af-field-type-true-false')
    .first()
    .addClass('first-of-type');
  $form
    .find('.af-field-type-checkbox, .af-field-type-true-false')
    .last()
    .addClass('last-of-type');

  // GA event on form change
  $form.find('input, select').on('change input', function (e) {
    const formName = $block.attr('data-ga-name');
    if (!$form.attr('data-ga-changed')) {
      $form.attr('data-ga-changed', 1);
      const event = new CustomEvent('ga-form-start', {
        detail: {
          formName,
        },
      });
      document.dispatchEvent(event);
    }
  });

  // AdIntelInit on form load
  if (typeof AdIntelInit === 'function') {
    AdIntelInit();
  } else {
    console.log('AdIntelInit undefined');
  }
}

export { initForm };

export default function form() {
  // Disable ACF popup
  $(function () {
    acf.unload.active = 0;
  });

  $('.block.form').each(function () {
    initForm($(this));
  });

  // Empty modal on close
  $('#modal-af').on('hidden.bs.modal', function () {
    $('#modal-af .modal-body').empty();
  });

  // Listen for server errors
  $(document).ajaxComplete(function (event, request, settings) {
    if (request.status === 500) {
      $('#modal-af .modal-body').html(
        `<h2 class="error">${wordpress.ui.error}</h2>`
      );
      $('#modal-af').modal();
    }
  });

  // Called after AJAX validation is complete but before errors are shown or the form is submitted.
  acf.add_filter('validation_complete', function (json, $form) {
    // Form is valid, trigger GA event
    if (json.valid) {
      const $block = $form.closest('.block.form');
      const formName = $block.attr('data-ga-name');

      // GA event form submit
      const formData = [];

      const $newsletter = $form.find(
        '.af-field[data-name="newsletter"] input[type="checkbox"]'
      );
      const newsletter = $newsletter.length && $newsletter.is(':checked');

      $form.find('select').each(function (index, value) {
        formData[$(this).closest('.af-field').attr('data-name')] = $(
          this
        ).val();
      });
      const eventFormSubmit = new CustomEvent('ga-form-submit', {
        detail: {
          formName,
          formData,
          newsletter,
        },
      });
      document.dispatchEvent(eventFormSubmit);
    }

    return json;
  });

  // If 'form_success' is in url, display success message in popup
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('form_success')) {
    const message = wordpress.afMessages[urlParams.get('form_success')];
    $('#modal-af .modal-body').html(message);
    $('#modal-af').modal();

    // Remove form_success from url
    if (typeof window.history !== 'undefined') {
      urlParams.delete('form_success');
      let newUrl = window.location.pathname;
      if (urlParams.toString()) {
        newUrl += `?${urlParams}`;
      }
      window.history.replaceState(null, null, newUrl);
    }
  }

  // If 'form_error' is in url, display error message in popup
  if (urlParams.get('form_error')) {
    // Error message in popup
    $('#modal-af .modal-body').html(
      `<h2 class="error">${wordpress.ui.error}</h2>`
    );
    $('#modal-af').modal();

    // Remove form_error from url
    if (typeof window.history !== 'undefined') {
      urlParams.delete('form_error');
      let newUrl = window.location.pathname;
      if (urlParams.toString()) {
        newUrl += `?${urlParams}`;
      }
      window.history.replaceState(null, null, newUrl);
    }
  }
}
